// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"8d58a8c3","851":"4b640cea"}[chunkId] + ".chunk.js";
};